import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React from "react";

const RadioNAButtons = ({ title, name, value, handleChange, disabled }) => {
  return (
    <Box>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "16px",
          mt: 2,
          textIndent: "-1rem",
          paddingLeft: "1rem",
        }}
        gutterBottom
      >
        {" "}
        {title}
      </Typography>
      <FormControl sx={{ my: 1, ml: 2.2 }}>
        <RadioGroup
          disabled={disabled}
          row
          value={value}
          name={name}
          onChange={handleChange}
        >
          <FormControlLabel
            value={"true"}
            control={<Radio disabled={disabled} />}
            label="Yes"
          />
          <FormControlLabel
            value={"false"}
            control={<Radio disabled={disabled} />}
            label="No"
          />
          <FormControlLabel
            value={"N/A"}
            control={<Radio disabled={disabled} />}
            label="Not Applicable"
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default RadioNAButtons;
